import { useCallback, useEffect, useRef, useState } from 'react';
import ApiDatabase from 'server';
import { isCanceledRequest } from 'components/perimeter/perimeterErrors';

const LOADING = { status: 'loading', perimeters: [], hasPerimeters: false };

// The active perimeters offered at invitation. `hasPerimeters` only turns
// true: a reload that finds none left must not remove the step the admin is on.
const useInvitationPerimeters = (idCompany) => {
  const [state, setState] = useState(LOADING);
  const latestRequest = useRef(null);

  const load = useCallback(() => {
    if (!idCompany) {
      setState((previous) => ({ ...previous, status: 'ready' }));
      return;
    }
    const request = {};
    latestRequest.current = request;
    ApiDatabase.getAdminCompanyPerimeters(
      { idCompany, status: 'active' },
      (answer) => {
        if (latestRequest.current !== request) return;
        const perimeters = Array.isArray(answer?.data) ? answer.data : [];
        setState((previous) => ({
          status: 'ready',
          perimeters,
          hasPerimeters: previous.hasPerimeters || perimeters.length > 0,
        }));
      },
      (err) => {
        if (latestRequest.current !== request || isCanceledRequest(err)) {
          return;
        }
        setState((previous) => ({ ...previous, status: 'error' }));
      },
      // Its own key: the contacts tab reads the same url, and a shared key
      // would let each request cancel the other.
      {
        abortKey: `admin/companies/${idCompany}/perimeters?status=active|invite`,
      },
    );
  }, [idCompany]);

  useEffect(() => {
    load();
    return () => {
      latestRequest.current = null;
    };
  }, [load]);

  const retry = () => {
    setState((previous) => ({ ...previous, status: 'loading' }));
    load();
  };

  return { ...state, reload: load, retry };
};

export default useInvitationPerimeters;
